import React from 'react';
import {
  CALCULATOR_TOOLTIP_CONTENT_TITLE,
  CALCULATOR_TOOLTIP_CONTENT_DESCRIPTION,
} from 'chameleon/packages/blue-book-player/library/QuestionCalculator/constants/calculatorTooltipContent';

const CalculatorTooltipContent = () => (
  <div
    className="flex flex-col justify-center items-center w-[420px] bb-mobile:w-[340px]"
    role="tooltip"
    aria-label="Calculator Tooltip Content"
  >
    <h2
      id="calculator-tooltip-content-title"
      className="text-base font-normal m-0"
    >
      {CALCULATOR_TOOLTIP_CONTENT_TITLE}
    </h2>
    <p id="calculator-tooltip-content-description" className="text-center mb-0">
      {CALCULATOR_TOOLTIP_CONTENT_DESCRIPTION}
    </p>
  </div>
);

export default CalculatorTooltipContent;
